/**应用组件路由 */
export default [
    {
        name: 'assembly',
        path: 'assembly',
        meta: { title: '应用组件' },
        component: () => import('@/pages/assembly/index.vue'),
        children: [
            {
                name: 'assembly',
                path: 'wxpacket',
                meta: { title: '微信关注扫码领红包' },
                component: () => import('@/pages/assembly/wxpacket.vue')
            },
            {
                name: 'assembly',
                path: 'integral',
                meta: { title: '扫码领积分' },
                component: () => import('@/pages/assembly/integral.vue')
            },
            {
                name: 'assembly',
                path: 'mall',
                meta: { title: '积分商城' },
                component: () => import('@/pages/assembly/mall.vue')
            },
            {
                name: 'assembly',
                path: 'list',
                meta: { title: '导购员名单' },
                component: () => import('@/pages/assembly/list.vue')
            },
            {
                name: 'assembly',
                path: 'info',
                component: () => import('@/pages/assembly/info.vue')
            },
            {
                name: 'assembly',
                path: 'turntable',
                meta: { title: '大转盘' },
                component: () => import('@/pages/assembly/turntable.vue')
            },
        ]
    }
]